export const parseErrorApi = (error: any) => {
  const data = error.response?.data || {};
  const { validation } = data?.errors || {};

  return validation || data?.error?.message;
};
